<template lang="html">
    <div class="centerx" style="min-width: 800px;">
		<vs-popup :title="'Contrat N°' + contractId + ' ' + societyName"  :active.sync="isPopupActive">
			<div class="container-fluid">
				<div class="container-fluid">
					<h4>Achats hors période</h4>
					<vs-table :data="list" pagination :max-items="15" stripe auto-resize>
						<template slot="thead">
							<vs-th class="text-center" sort-key="user_name"><vs-spacer /><span>Ajouté par</span><vs-spacer /></vs-th>
							<vs-th class="text-center" sort-key="service_name"><vs-spacer /><span>Service</span><vs-spacer /></vs-th>
							<vs-th class="text-center" sort-key="provider_name"><vs-spacer /><span>Prestataire</span><vs-spacer /></vs-th>
							<vs-th class="text-center" sort-key="price"><span class="w-full text-right">Prix Achat (HT)</span></vs-th>
							<vs-th class="text-center" sort-key="sell_price"><vs-spacer /><span>Prix de Vente (HT)</span></vs-th>
							<vs-th class="text-center" sort-key="input_date"><vs-spacer /><span>Date de saisie</span><vs-spacer /></vs-th>
							<vs-th class="text-center" sort-key="input_date"><vs-spacer /><span>Période</span><vs-spacer /></vs-th>
							<vs-th class="text-center" sort-key="recurrence"><vs-spacer /><span>Récurrence</span><vs-spacer /></vs-th>
							<!-- <vs-th class="text-center">Est un achat récurrent ?</vs-th> -->
							<vs-th class="text-center" sort-key="is_billable"><vs-spacer /><span>Facturable</span><vs-spacer /></vs-th>
							<vs-th class="text-center" sort-key="commentary"><vs-spacer /><span>Commentaire</span><vs-spacer /></vs-th>
						</template>
						<template slot-scope="{data}">
							<vs-tr :key="index" v-for="(purchase, index) in data">
								<vs-td :data="purchase.user_id" class="text-center pdl0">
									<span class="hvr-underline hvr-underline-out">
										<vx-tooltip
											:text="`${purchase.user_firstname} ${purchase.user_lastname}`"
											position="top"
											style="text-align: center;"
										>
											<vs-avatar
												style="border: 1px solid gray;"
												:text="`${purchase.user_firstname} ${purchase.user_lastname}`"
												:src="getCollaboratorAvatar(purchase.user_id)"
											/>
										</vx-tooltip>
									</span>
								</vs-td>
								<vs-td :data="purchase.service_name" class="text-center pdl0">{{ getServiceIdToName(purchase.service_id) }}</vs-td>
								<vs-td :data="purchase.provider_name" class="text-center pdl0"> {{ getProviderIdToName(purchase.users_id) }}</vs-td>
								<vs-td :data="purchase.price" class="text-right" style="padding-right: 13px;"> {{ purchase.recurrence_date ? convertInternationalNumberToFrenchCurrency(purchase.recurrence_price) : convertInternationalNumberToFrenchCurrency(purchase.price) }}</vs-td>
								<vs-td :data="purchase.sell_price" class="text-right" style="padding-right: 13px;" v-if="purchase.is_billable"> {{ purchase.recurrence_date ? convertInternationalNumberToFrenchCurrency(purchase.recurrence_price) : convertInternationalNumberToFrenchCurrency(purchase.sell_price) }}</vs-td>
								<vs-td :data="purchase.sell_price" class="text-right" v-else></vs-td>
								<vs-td :data="purchase.input_date" class="text-center pdl0"> {{ purchase.recurrence_date ? getDateToFrenchFormat(formatDate(purchase.recurrence_date)) : getDateToFrenchFormat(formatDate(purchase.input_date)) }}</vs-td>
								<vs-td :data="purchase.period_date" class="text-center pdl0"> {{ purchase.period_date && purchase.period_date.length >= 10 ? purchase.period_date.substring(0,7).split("-").reverse().join("/") : "" }}</vs-td>
								<vs-td :data="purchase.recurrence" class="text-center pdl0"> {{ getPurchaseFrequency(purchase.recurrence) }}</vs-td>
								<!-- <vs-td :data="purchase.recurrence_date" class="text-center"> {{ purchase.recurrence_date ? "Oui" : "Non" }}</vs-td> -->
								<vs-td :data="purchase.is_billable" class="text-center pdl0"> {{ getUserDashboardAccess(purchase.is_billable) }}</vs-td>
								<vs-td :data="purchase.commentary" class="text-center pdl0"> {{ purchase.commentary }}</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</div>
      		</div>
    	</vs-popup>
  	</div>
</template>


<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import "@/assets/css/toggle-switch.css";


export default {
	name: "PurchasesViewerPopup",
	props: {
		popupActive: Boolean,
		apiUrl: String,
		contractId: Number,
		societyName: String,
		allCollaboratorsAvatar: Array,
		services: Array,
		societies: Array,
		providers: Array,
		list: Array
	},
	mixins: [dbFieldConvertor, utilsMixin],
	created(){
	},
	data() {
		return {
			isPopupActive: this.$props.popupActive
		};
	},

	methods: {
		formatDate(date_input){
			if(date_input && date_input.length > 10){
				return date_input.substring(0, 10);
			}
			else{
				return date_input;
			}
		},

		getCollaboratorAvatar(userId){
			let foundAvatar = this.allCollaboratorsAvatar.find(avatar => avatar.id == userId);
			if(foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		getProviderIdToName(provider_id){
			let provider_name = "";
			let provider = this.providers.find(provider => provider.id == provider_id);
			if(provider != undefined && provider.society != undefined){
				provider_name = provider.society;
			}
			return provider_name;
		},
		getServiceIdToName(service_id){
			let service_name = "";
			let service = this.services.find(service => service.id == service_id);
			if(service != undefined && service.name != undefined){
				service_name = service.name;
			}
			return service_name;
		}
	}
};
</script>

<style scoped>
.table-client{
  padding: 0 20px 20px 20px;
}
.thead-client{
  white-space: nowrap;
}
.center {
  justify-content: center;
}

.hvr-underline-out{
  color: black;
}
.hvr-underline:hover{
  color:aqua;
  text-decoration: underline;
  cursor: pointer;
}
</style>
